import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface IProps {
  size?: 'sm' | 'md' | 'lg'
  dotted?: false
  color?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KDivider' },
  __name: 'KDivider',
  props: {
    size: { default: 'sm' },
    dotted: { type: Boolean, default: false },
    color: { default: 'cool-gray-30' }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-divider", [
      !__props.dotted ? `k-divider--size-${__props.size}` : '',
      'text-' + __props.color,
      {
        'k-divider--dotted': __props.dotted,
        'k-divider--dotted-darker': __props.dotted && __props.color === 'cool-gray-80',
      },
    ]])
  }, null, 2 /* CLASS */))
}
}

})